function addApiHost(integrations, integration, apiHost) {
    if (integrations && integration) {
        integrations[integration] = {
            apiHost: apiHost
        };
    }
}

module.exports = {
    addApiHost
};
